import { notification } from 'antd';

export const displayMessage = (description, error) => {
	if (error) {
		notification.error({
			message: 'Error',
			description,
		});
		console.error(error);
	} else {
		notification.success({
			message: 'Success',
			description,
		});
	}
};
